import React from "react";
import { useListContext, useResourceContext } from "react-admin";
import { MenuItem } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { FieldTitle } from "ra-core";
import { MobileListMenu } from "./MobileListMenu";

type FilterProps = {
  alwaysOn?: boolean;
  defaultValue?: string;
  disabled?: boolean;
  label?: string | React.ReactElement | boolean;
  source: string;
};

type Props = {
  filters: React.ReactNode[];
};

export const MobileFilterButton = ({ filters }: Props) => {
  const resource = useResourceContext();
  const { displayedFilters = {}, filterValues, setFilters, showFilter } = useListContext();
  const filterElements = filters.filter(React.isValidElement) as React.ReactElement<FilterProps>[];
  const hiddenFilters = filterElements.filter(
    (filter) =>
      !filter.props.alwaysOn &&
      !displayedFilters[filter.props.source] &&
      typeof filterValues[filter.props.source] === "undefined"
  );
  const hasFilterValues = Object.keys(filterValues).length > 0;

  if (hiddenFilters.length === 0 && !hasFilterValues) {
    return null;
  }

  return (
    <MobileListMenu
      buttonIcon={<FilterListIcon />}
      buttonLabel="検索条件"
      menuId="mobile-filter-menu"
      renderMenuItems={(closeMenu) => (
        <>
          {hiddenFilters.map((filter) => (
            <MenuItem
              disabled={filter.props.disabled}
              key={filter.props.source}
              onClick={() => {
                showFilter(
                  filter.props.source,
                  filter.props.defaultValue === "" ? undefined : filter.props.defaultValue
                );
                closeMenu();
              }}
            >
              <FieldTitle label={filter.props.label} resource={resource} source={filter.props.source} />
            </MenuItem>
          ))}
          {hasFilterValues && (
            <MenuItem
              onClick={() => {
                setFilters({}, {}, false);
                closeMenu();
              }}
            >
              すべての検索条件を解除
            </MenuItem>
          )}
        </>
      )}
    />
  );
};
